import React, { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import toast from "react-hot-toast";
import { AiFillCloseCircle } from "react-icons/ai";
import { FaDeleteLeft } from "react-icons/fa6";
import ButtonLoader from "../common/ButtonLoader";

const SeeRoomDetails = ({ setLoadRoomDetails, currentRoomDetails }) => {
  const [check, setCheck] = useState(false);
  const [load, setLoad] = useState(false);
  const [beds, setBeds] = useState(currentRoomDetails.beds);
  const [addBedLoader, setAddBedLoader] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [sharingType, setSharingType] = useState(
    currentRoomDetails.sharingType
  ); // State for tracking sharing type

  const [totalBeds, setTotalBeds] = useState(currentRoomDetails.numberOfBeds);

  console.log("Room Details:", currentRoomDetails);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      buildingId: currentRoomDetails.buildingId,
      facilities: currentRoomDetails.facilities,
      floorNumber: currentRoomDetails.floorNumber,
      numberOfBeds: currentRoomDetails.numberOfBeds,
      roomNumber: currentRoomDetails.roomNumber,
      sharingType: currentRoomDetails.sharingType,
      bedRent: currentRoomDetails.bedRent,
    },
  });

  const handleRoomSubmit = (data) => {
    setLoad(true);

    // Define the maximum beds for each sharing type
    const maxBeds = sharingType;

    // Check the selected sharing type and current number of beds
    const currentBedsCount = beds.length; // Total number of beds in the room
    const maxAllowedBeds = maxBeds; // Max beds allowed based on sharing type

    // Prevent adding more beds if the limit is reached
    if (currentBedsCount > maxBeds) {
      setLoad(false);

      toast.error(
        `This is a ${
          Number(sharingType) === 1
            ? "single sharing"
            : Number(sharingType) === 2
            ? "double sharing"
            : Number(sharingType) === 3
            ? "triple sharing"
            : `${sharingType}-sharing`
        } room. Please remove ${currentBedsCount - maxAllowedBeds} ${
          currentBedsCount - maxAllowedBeds == 1 ? "bed" : "beds"
        }. Cannot add more than allowed number of beds !`
      );
      return;
    }

    let config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/rooms/update_room/${currentRoomDetails._id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { ...data, numberOfBeds: totalBeds },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        toast.success(response.data.message);
        setLoad(false);
        setLoadRoomDetails(false);
      })
      .catch((error) => {
        console.log(error);
        setLoad(false);
        toast.error(error.response.data.message);
      });
  };

  const clearRoomDetails = (id) => {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/rooms/delete_room/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        toast.success(response.data.message);
        setLoadRoomDetails(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.message);
      });
  };

  const handleBedsChange = (e) => {
    const bedCount = parseInt(e.target.value, 10);

    // Determine the maximum beds based on sharing type
    const maxBeds =
      sharingType === "Single Sharing"
        ? 1
        : sharingType === "Double Sharing"
        ? 2
        : sharingType === "Triple Sharing"
        ? 3
        : Infinity;

    if (bedCount > maxBeds) {
      toast.error(`Maximum ${maxBeds} beds allowed for ${sharingType}`);
      setValue("numberOfBeds", maxBeds); // Reset the value to the maximum allowed
      reset({
        numberOfBeds: "",
      });
      return;
    }

    // const bedsList = Array.from({ length: bedCount }, (_, idx) => ({
    //   bedNumber: `B${idx + 1}`,
    // }));

    if (currentRoomDetails.beds.length > bedCount) {
      // If there are more beds than bedCount, slice the array to match bedCount
      setBeds(currentRoomDetails.beds.slice(0, bedCount));
    } else {
      // If there are fewer beds than bedCount, calculate how many more beds are needed
      const value = bedCount - currentRoomDetails.beds.length;
      const additionalBeds = [];

      // Generate the additional beds
      for (let i = 1; i <= value; i++) {
        additionalBeds.push({
          bedNumber: `B${currentRoomDetails.beds.length + i}`,
          isOccupied: false,
          underNotice: false,
          roomId: currentRoomDetails._id,
        });
      }

      // Combine the existing beds with the new beds to match bedCount
      setBeds([...currentRoomDetails.beds, ...additionalBeds]);
    }
  };

  const addBed = (roomId) => {
    // Define the maximum beds for each sharing type
    const maxBeds = sharingType;

    // Check the selected sharing type and current number of beds
    const currentBedsCount = beds.length; // Total number of beds in the room

    // Prevent adding more beds if the limit is reached
    if (currentBedsCount >= maxBeds) {
      toast.error(
        `Maximum beds reached for ${
          Number(sharingType) === 1
            ? "single sharing room"
            : Number(sharingType) === 2
            ? "double sharing room"
            : Number(sharingType) === 3
            ? "triple sharing room"
            : `${sharingType}-sharing room`
        }. Cannot add more beds.`
      );
      return;
    }

    // // Step 1: Extract all bed numbers and sort them
    // const existingBedNumbers = beds
    //   .map((bed) => parseInt(bed.bedNumber.slice(1))) // Remove 'B' and convert to number
    //   .sort((a, b) => a - b); // Sort in ascending order

    // setAddBedLoader(true);
    // // Step 2: Find the first missing number or generate the next number
    // let newBedNumberValue = 1; // Start with B1
    // for (let i = 0; i < existingBedNumbers.length; i++) {
    //   if (existingBedNumbers[i] !== newBedNumberValue) {
    //     break; // Missing number found
    //   }
    //   newBedNumberValue++;
    // }

    // // Step 3: Generate the new bed number
    // const newBedNumber = `B${newBedNumberValue}`;
    // console.log("new Bed Number--->", newBedNumber);
    // Step 1: Extract and sort existing bed numbers
    const existingBedNumbers = beds
      .map((bed) => {
        const match = bed.bedNumber.match(/B-F\d+R\d+(\d{2})/); // Extract the last two digits (NN)
        return match ? parseInt(match[1], 10) : null;
      })
      .filter((num) => num !== null) // Remove any invalid values
      .sort((a, b) => a - b); // Sort in ascending order

    setAddBedLoader(true);

    // Step 2: Find the first missing bed number in sequence
    let newBedNumberValue = 1;
    for (let i = 0; i < existingBedNumbers.length; i++) {
      if (existingBedNumbers[i] !== newBedNumberValue) {
        break; // Found a missing number
      }
      newBedNumberValue++;
    }

    // Step 3: Generate the new bed number with the correct format
    const newBedNumber = `B-F${currentRoomDetails?.floorNumber}R${
      currentRoomDetails?.roomNumber
    }${String(newBedNumberValue).padStart(2, "0")}`;

    const myData = {
      roomId: roomId,
      bedNumber: newBedNumber,
      numberOfBeds: totalBeds,
    };
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/beds/create-bed`,
      headers: {
        "Content-Type": "application/json",
      },
      data: myData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        toast.success(response.data.message);
        setAddBedLoader(false);
        getCurrentRoomsById();
      })
      .catch((error) => {
        console.log(error);
        setAddBedLoader(false);
        toast.error(error.response.data.message);
      });
  };

  const deleteBed = (id) => {
    setDeleteLoader(true);
    const myData = {
      id: id,
      numberOfBeds: totalBeds,
    };
    if (window.confirm("Are you sure you want to delete this item ?")) {
      let config = {
        method: "delete",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/beds/delete-bed`,
        headers: {
          "Content-Type": "application/json",
        },
        data: myData,
      };

      axios
        .request(config)
        .then((response) => {
          console.log(response.data);
          setDeleteLoader(false);
          toast.success(response.data.message);
          getCurrentRoomsById();
        })
        .catch((error) => {
          console.log(error);
          setDeleteLoader(false);
          toast.error(error.response.data.message);
        });
    }
  };

  const getCurrentRoomsById = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/rooms/get_room_by_id/${currentRoomDetails._id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data.data);
        // setRoomsByBuilding(response.data.data);
        setTotalBeds(response.data.data.beds.length);
        setBeds(response.data.data.beds);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="w-full bg-[#00000077] fixed inset-0 z-50 flex justify-center items-center">
      {/* Room Deatils Container */}
      <div
        className={`w-[30rem] p-6 bg-white relative rounded-xl tracking-wide text-xl font-semibold ${
          check ? "hidden" : "block"
        }`}
      >
        <h2 className="text-2xl mb-4 font-bold">Room Details</h2>

        {/* Display each property except "_id" */}
        <div className="space-y-3 text-lg">
          {Object.entries(currentRoomDetails)
            .filter(
              ([key]) =>
                key !== "_id" &&
                key !== "__v" &&
                key !== "buildingId" &&
                key !== "createdAt" &&
                key !== "updatedAt"
            ) // Exclude _id and other unwanted fields
            .map(([key, value]) => {
              // Format roomNumber to "R-F2001" format
              if (key === "roomNumber") {
                value = `R-F${currentRoomDetails.floorNumber}${String(
                  value
                ).padStart(3, "0")}`;
              }

              // Join array elements with commas or show "N/A"
              if (key === "facilities" && Array.isArray(value)) {
                value = value.length > 0 ? value.join(", ") : "N/A";
              }

              // Join bed numbers as a comma-separated string
              if (key === "beds" && Array.isArray(value)) {
                value =
                  value.length > 0
                    ? value.map((bed) => bed.bedNumber).join(", ")
                    : "N/A";
              }
              if (key === "sharingType") {
                value =
                  value === 1
                    ? "Single Sharing"
                    : value === 2
                    ? "Double Sharing"
                    : value === 3
                    ? "Triple Sharing"
                    : `${value}-Sharing`;
              }
              return (
                <div key={key} className="flex justify-between gap-4">
                  <span className="capitalize">
                    {key.replace(/([A-Z])/g, " $1")}
                  </span>
                  <span>{value}</span>
                </div>
              );
            })}
        </div>

        <div className="flex gap-4 items-end justify-end mt-6">
          {/* <button className="px-4 py-2 rounded-md bg-white border font-medium hover:bg-secondaryTextColor">
            Close
          </button> */}
          <AiFillCloseCircle
            onClick={() => setLoadRoomDetails(false)}
            className="cursor-pointer text-primaryColor absolute top-4 right-4 "
            size={30}
          />
          <button
            onClick={() => clearRoomDetails(currentRoomDetails._id)}
            className="px-4 py-2 rounded-md bg-white border font-medium duration-200 hover:bg-secondaryTextColor hover:text-white"
          >
            Clear Data
          </button>
          <button
            onClick={() => {
              setCheck(true);
            }}
            className="px-4 py-2 text-white rounded-md font-medium duration-200 bg-primaryBtnColor hover:bg-primaryBtnHoverColor"
          >
            Edit
          </button>
        </div>
      </div>

      {/* Room Edit Container */}
      <div
        className={`w-[30rem] bg-white p-6 rounded-md shadow-md  ${
          check ? "block" : "hidden"
        } `}
      >
        <h1 className="text-center font-bold mb-4 text-xl "> Edit Room</h1>
        <h2 className="text-lg font-bold tracking-wide  flex items-center justify-between  mb-6">
          <span className="float-right">
            {" "}
            Room No : R-F{currentRoomDetails.floorNumber}
            {String(currentRoomDetails?.roomNumber).padStart(3, "0")}
          </span>
          <span className="float-right">
            {" "}
            Floor No : {currentRoomDetails.floorNumber}
          </span>
        </h2>

        {/* -------------------------------------------------------- */}
        {/* form for configure room edit */}

        <form onSubmit={handleSubmit(handleRoomSubmit)} className="space-y-4">
          {/* Sharing Type */}
          <div>
            <label className="block text-gray-700">Sharing Capacity</label>
            <input
              type="text"
              placeholder="Enter sharing capacity"
              // disabled={sharingType ? false : true}
              {...register("sharingType", {
                required: "Sharing is required",
              })}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, ""); //Doesn't allow any non-numeric value

                if (e.target.value === "") {
                  setSharingType("");
                  return;
                } //Allows backspacing

                if (e.target.value < 1) {
                  e.target.value = 1; // Prevent values below 1
                  toast.error("Minimum sharing type is 1");
                } else if (e.target.value > 10) {
                  e.target.value = 10; // Prevent values above 10
                  toast.error("Maximum sharing type is 10");
                }
                setSharingType(e.target.value);
              }}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
            />
            {errors.sharingType && (
              <p className="text-red-500 text-sm mt-1">
                {errors.sharingType.message}
              </p>
            )}
          </div>

          {/* Number of Beds */}
          <div className="flex items-center gap-2">
            <h3 className="block text-gray-700">Total Number of Beds : </h3>
            <div className="w-6 h-6 flex items-center justify-center rounded-full border-2 border-primaryColor">
              {totalBeds}
            </div>
          </div>
          <div className=" relative min-h-24">
            <button
              type="button"
              disabled={addBedLoader}
              onClick={() => {
                addBed(currentRoomDetails._id);
              }}
              className="text-white font-semibold tracking-wide rounded-md px-3 py-1  absolute top-1 right-1 bg-primaryBtnColor hover:bg-primaryBtnHoverColor"
            >
              {addBedLoader ? <ButtonLoader /> : "Add Bed"}
            </button>
            <span>Bed Numbers: </span>
            <br />
            <div className="flex flex-wrap items-center gap-2 p-3 rounded-md bg-primarybgColor mt-5">
              {beds
                .sort((a, b) => {
                  const numA = parseInt(a.bedNumber.slice(1)); // Extract the number after 'B'
                  const numB = parseInt(b.bedNumber.slice(1)); // Extract the number after 'B'
                  return numA - numB; // Compare the numbers
                })
                .map((each) => {
                  return (
                    <div className="p-1 w-fit flex items-center gap-2  rounded-md mx-1 text-white font-semibold bg-primaryBtnColor">
                      {each.bedNumber}
                      <FaDeleteLeft
                        onClick={() => {
                          deleteBed(each._id);
                        }}
                        size={25}
                        color="#F95454"
                        className="cursor-pointer"
                      />
                    </div>
                  );
                })}

              {deleteLoader && <ButtonLoader />}
            </div>
          </div>

          {/* Bed Rent  */}
          <div>
            <label className="block text-gray-700">Bed Rent</label>
            <input
              type="text"
              min={1}
              placeholder="Enter bed rent"
              {...register("bedRent", { required: "Bed Rent is required" })}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, ""); //Doesn't allow any non-numeric value
              }}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Facilities */}
          <div>
            <label className="block text-gray-700">Facilities</label>
            <div className="mt-1 grid grid-cols-2">
              {[
                "Air Conditioner",
                "Attached Toilet",
                "Attached Balcony",
                "Geyser",
              ].map((facility) => (
                <label key={facility} className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    {...register("facilities")}
                    value={facility}
                    defaultChecked={currentRoomDetails.facilities.includes(
                      facility
                    )}
                    className="form-checkbox"
                  />
                  <span>{facility}</span>
                </label>
              ))}
            </div>
            {errors.facilities && (
              <p className="text-red-500 text-sm mt-1">
                {errors.facilities.message}
              </p>
            )}
          </div>

          {/* Submit Button */}
          <div className="flex items-center gap-3 text-xl">
            <button
              onClick={() => {
                setLoadRoomDetails(false);
              }}
              type="button"
              className="w-full  py-2 rounded-md transition duration-200 border hover:bg-slate-200"
            >
              Close
            </button>
            <button
              type="submit"
              className="w-full bg-primaryBtnColor text-white py-2 rounded-md hover:bg-primaryBtnHoverColor transition duration-200"
            >
              {load ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SeeRoomDetails;
